export type PageSurfaceMode = "white" | "tint";

export const PAGE_SURFACE_MODE: PageSurfaceMode = "tint";

const PAGE_SURFACES = {
  white: {
    appBackground: "#ffffff",
    pageBackground: "#ffffff",
    pageBackgroundGradient: "linear-gradient(180deg, #ffffff 0%, #ffffff 100%)",
    sectionBackground: "#ffffff",
    elevatedPanel: "#ffffff",
    elevatedPanelGradient:
      "linear-gradient(180deg, rgba(255,255,255,0.99) 0%, rgba(255,255,255,0.99) 100%)",
    border: "rgba(15, 23, 42, 0.08)",
  },
  tint: {
    appBackground: "#eef3f8",
    pageBackground: "#f5f8fb",
    pageBackgroundGradient:
      "linear-gradient(180deg, #eef3f8 0%, #f5f8fb 22%, #f9fbfc 56%, #ffffff 100%)",
    sectionBackground: "#f8fbff",
    elevatedPanel: "#ffffff",
    elevatedPanelGradient:
      "linear-gradient(180deg, rgba(248,250,255,0.98) 0%, rgba(255,255,255,0.99) 100%)",
    border: "rgba(29, 78, 216, 0.12)",
  },
} as const;

export function getPageSurfaceConfig() {
  return PAGE_SURFACES[PAGE_SURFACE_MODE];
}

export function getPageSurfaceGradient() {
  return PAGE_SURFACES[PAGE_SURFACE_MODE].pageBackgroundGradient;
}

export function getPageSurfaceSolid() {
  return PAGE_SURFACES[PAGE_SURFACE_MODE].pageBackground;
}

export function getElevatedPageSurfaceGradient() {
  return PAGE_SURFACES[PAGE_SURFACE_MODE].elevatedPanelGradient;
}
